var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 6a45.13 45.13 0 00-45.08 45.17l-9.51-9.51a2 2 0 00-2.82 2.83l12.92 12.92a2 2 0 002.83 0l12.92-12.92a2 2 0 00-2.83-2.83l-9.51 9.51A41.13 41.13 0 0160 10a2 2 0 000-4z",
    fill: "#1253fa",
    "data-original": "#000000",
    "data-name": "Layer 40"
  })));
}
export default SvgBlueArrow;